import React from 'react'
import PropTypes from 'prop-types'
import DataSource from '../DataSource'
import ButtonWithLoader from '../elements/ButtonWithLoader'
import moment from 'moment'
import globals from '../globals'

class StreamCsv extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoading: false,
            isLoaded: false
        }
    }

    stream (event) {
        event.preventDefault()
        this.setLoading()
        DataSource.getBlob(this.props.apiUrl, response => {
            this.showFile(response)
            this.setLoaded()
            if (this.props.gaEvent) {
			    globals.pushEvent(this.props.gaEvent)
            }
        })
    }

    getDate () {
        const year = moment().format('YYYY')
        const month = String(moment().format('M')).length === 1 ? `0${moment().format('M')}` : moment().format('M')
        const day = String(moment().format('D')).length === 1 ? `0${moment().format('D')}` : moment().format('D')

        return `${year}${month}${day}`
    }

    showFile (blob) {
        // It is necessary to create a new blob object with mime-type explicitly set otherwise only Chrome works like it should
        const newBlob = new Blob([blob], { type: 'application/csv' })

        // IE doesn't allow using a blob object directly as link href instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
        }

        // For other browsers:  Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob)
        const link = document.createElement('a')

        link.setAttribute('href', data)
        link.setAttribute('download', this.props.outputFilename ? `${this.props.outputFilename}.csv` : `${this.getDate()}-export.csv`)
        link.click()

        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data)
        }, 100)
    }

    setLoading () {
        this.setState({ isLoading: true, isLoaded: false })
    }

    setLoaded () {
        this.setState({ isLoading: false, isLoaded: true })
    }

    render () {
        return (
            <ButtonWithLoader
                title={this.props.btnTitle}
                isLoading={this.state.isLoading}
                isLoaded={this.state.isLoaded}
                action={this.stream.bind(this)}
            />
        )
    }
}

StreamCsv.propTypes = {
    apiUrl: PropTypes.string.isRequired,
    btnTitle: PropTypes.string,
    outputFilename: PropTypes.string,
    gaEvent: PropTypes.string
}

StreamCsv.defaultProps = {
    btnTitle: 'Export CSV'
}

export default StreamCsv



// WEBPACK FOOTER //
// ./resources/js/components/StreamCsv.js